// extracted by mini-css-extract-plugin
export default {"container":"SelectUserChat_container__yf5h0","card":"SelectUserChat_card__yWLrk","copy":"SelectUserChat_copy__T+O0g"};